import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { ServiceTypeModel } from './model';
import { ServiceTypeState } from './state';
import * as selectors from './selectors';
import { UserFacade } from '../user/facade';
import * as actions from './actions';

@Injectable()
export class ServiceTypeFacade {
  private store = inject<Store<ServiceTypeState>>(Store);
  private userFacade = inject(UserFacade);

  allServiceTypes$ = this.store.pipe(select(selectors.selectAll));

  constructor() {
    this.getAll();
  }

  public getAll() {
    this.userFacade.selected().subscribe(user => {
      if (user) {
        this.store.dispatch(new actions.LoadRequestAction());
      }
    });
  }

  getById(id: number): Observable<ServiceTypeModel> {
    return this.store.pipe(select(selectors.selectById(id)));
  }

  getError(): Observable<any> {
    return this.store.pipe(select(selectors.selectError));
  }

  isLoading(): Observable<boolean> {
    return this.store.pipe(select(selectors.selectIsLoading));
  }
}
